module.exports = "/packs/images/svg/weekly-prog/calendar~b0d0b2bdfae6d0c0de0f77a85807d835.svg";